/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext } from 'react';
import CustomButton from '../../../../shared/forms/CustomButton';
import CustomInput from '../../../../shared/forms/CustomInput';
import SnmpCactiContext from './context/SnmpCactiContext';
import Label from '../../../../shared/forms/Label';

const AddSnmpCacti = () => {
  const { loadingForm, onChange, formValue, onSubmit } = useContext(SnmpCactiContext);
  const { basestation_name, router, ip_address, router_firmware, customer_ip, snmp, l2tp } = formValue;
  const submitForm = () => {
    return (
      basestation_name.length > 0 &&
      router.length > 0 &&
      ip_address.length > 0 &&
      router_firmware.length > 0 &&
      customer_ip.length > 0 &&
      snmp.length > 0 &&
      l2tp.length > 0
    );
  };
  return (
    <div id="add-access-point" className="modal fade mt-5" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header shadow">
            <h4 className="modal-title update_asset">SNMP CACTI</h4>
            <button type="button" className="btn btn-outline-info btn-circle btn-close" data-dismiss="modal">
              x
            </button>
          </div>
          <div className="modal-body detail mb-4 p-0">
            <form
              className="col-md-12 p-0"
              onSubmit={(e) => {
                e.preventDefault();
                onSubmit();
              }}
            >
              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="basestation name" htmlfor="customerName" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="basestation_name"
                    value={basestation_name}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="Enter basestation Name"
                    type="text"
                    id="customerName"
                  />
                </div>
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Router" htmlfor="customerEmail" />
                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="router"
                    value={router}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="Router"
                    type="text"
                    id="customerEmail"
                  />
                </div>
              </div>
              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="IP Address" htmlfor="router_id" />

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="ip_address"
                    value={ip_address}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="e.g (21.1)"
                    type="text"
                    id="router_id"
                  />
                </div>
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Router Firmware" htmlfor="radioMACID" />

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="router_firmware"
                    value={router_firmware}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="Routter Firmware"
                    type="text"
                    id="radioMACID"
                  />
                </div>
              </div>

              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="Customer Ip" htmlfor="router_id" />

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="customer_ip"
                    value={customer_ip}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="Customer IP"
                    type="text"
                    id="router_id"
                  />
                </div>
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="SNMP" htmlfor="radioMACID" />

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="snmp"
                    value={snmp}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="SNMP"
                    type="text"
                    id="radioMACID"
                  />
                </div>
              </div>
              <div className="d-flex">
                <div className="form-group col-6">
                  <Label classname="m-0 p-0 copy-font" name="l2tp" htmlfor="router_id" />

                  <CustomInput
                    classname="form-control border border-info p-2"
                    name="l2tp"
                    value={l2tp}
                    onChange={onChange}
                    readOnly={false}
                    placeholder="Enter L2TP"
                    type="text"
                    id="router_id"
                  />
                </div>
              </div>
              <div className="text-center mt-3">
                {loadingForm ? (
                  <CustomButton classname="btn btn-green px-3" name="Adding" disabled={loadingForm} />
                ) : (
                  <CustomButton classname="btn btn-green px-3" name="Add" disabled={!submitForm()} />
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSnmpCacti;
